import { isPossiblePhoneNumber } from 'libphonenumber-js';
import { AppFormItem, AppFormItemProps, AppPhoneInput } from 'components/atoms';
import { formFields } from 'consts/form/formFields';
import { createFieldValidationRules } from 'utils/formValidationHelpers';
import { isValidPhoneNumberLength } from 'utils/isValidPhoneNumberLength';

export type PhoneNumberInputElementProps = AppFormItemProps & {
    optional?: boolean;
};

export const PhoneNumberInputElement = ({
    optional = false,
    ...props
}: PhoneNumberInputElementProps) => {
    const validationRules = createFieldValidationRules('phoneNumber', {
        required: !optional,
        customValidator: (value): boolean => {
            const isPossibleNumber = value && isPossiblePhoneNumber(value as string, 'PL');
            const isNumberCorrect = isPossibleNumber && isValidPhoneNumberLength(value as string);
            const isInputEmpty = !value;
            const isValidationCorrect = optional
                ? isInputEmpty || isNumberCorrect
                : isNumberCorrect;

            return Boolean(isValidationCorrect);
        },
        customErrorMessage: 'Numer jest niepoprawny',
    });

    return (
        <AppFormItem
            label="Numer telefonu"
            optional={optional}
            hasOptionalText={optional}
            name={formFields.phoneNumber}
            rules={validationRules}
            {...props}
        >
            <AppPhoneInput autoComplete="tel-national" placeholder="Podaj numer telefonu" />
        </AppFormItem>
    );
};
